module.exports = __webpack_public_path__ + "img/banner1.17a52dd0.png";